import '@styles/main.css';
import { initialiseSite, normalisePage } from './site.js';

document.documentElement.classList.add('js');
document.documentElement.dataset.page = normalisePage(document.body?.dataset.page);
initialiseSite(document);
